export default "__VITE_ASSET__a56d00c2__"